<template>
  <div>
    <Navbar v-if="$route.name == 'mailsettings'"/>
    <!-- <Breadcrumb v-if="$route.name == 'mailsettings'" /> -->
    <div class="col-12 px-0 mx-0 mt-2">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 0}"
            @click="activeTab = 0"
            type="button"
          >
            <fa-icon class="me-2" name="envelope-open-text" />
            Mail to new user
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 1}"
            @click="activeTab = 1"
            type="button"
          >
            <fa-icon class="me-2" name="envelope-open-text" />
            Invoice notification to admin
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 2}"
            @click="activeTab = 2"
            type="button"
          >
            <fa-icon class="me-2" name="tasks" />
            Mail Servers
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 3}"
            @click="activeTab = 3"
            type="button"
          >
            <fa-icon class="me-2" name="search" />
            Mail queue
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 4}"
            @click="activeTab = 4"
            type="button"
          >
            <fa-icon class="me-2" name="cog" />
            Test mail addresses
          </button>
        </li>
      </ul>
      <div class="tab-content mt-3">
        <div v-if="activeTab === 0" class="tab-pane show active">
          <div class="border-0 mx-0 px-0 col-12">
            <DefaultMailNewUser />
          </div>
        </div>
        <div v-if="activeTab === 1" class="tab-pane show active">
          <div class="border-0 mx-0 px-0 col-12">
            <DefaultMailNewInvoice />
          </div>
        </div>
        <div v-if="activeTab === 2" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_mailservers" />
          </div>
        </div>
        <div v-if="activeTab === 3" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_mailqueue" noedit="true"/>
          </div>
        </div>
        <div v-if="activeTab === 4" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <TestMailAddresses />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DefaultMailNewUser from './DefaultMailNewUser';
import DefaultMailNewInvoice from './DefaultMailNewInvoice';
import Maintenance from './Maintenance';
import TestMailAddresses from './TestMailAddresses.vue';
import Navbar from './Navbar.vue';
// import Breadcrumb from './Breadcrumb.vue';
export default {
  name: 'MailSettings',
  mounted() {
    this.prefs_get();
  },
  components: {
    DefaultMailNewUser,
    DefaultMailNewInvoice,
    Maintenance,
    TestMailAddresses,
    Navbar,
    // Breadcrumb,
},
  data: function() {
    return {
      activeTab: 0,
      gdqreport_price: 0,
      gdq_vat: 0,
    }
  },
  methods: {
    savepref(key,value) {
      if (key.indexOf('_date') != -1) {
        value = this.format_date(value);
      }
      this.$store.dispatch('syspref_save', { key: key,value: value });
    },
    prefs_get() {
      this.$store.dispatch('syspref_fetch', { key: 'gdqreport_price' })
      .then((resp) => {
        this.gdqreport_price = resp.data.value;
        this.$store.dispatch('syspref_fetch', { key: 'gdq_vat' })
        .then((resp) => {
          this.gdq_vat = resp.data.value;
        });
      });
    },
  },
}
</script>
<style>
</style>
